export default {
  home: {
    navigation: [
      { name: 'Logos', scroll: 'logos' },
      { name: 'Colours', scroll: 'colours' },
      { name: 'Press media', scroll: 'press' },
      { name: 'Presentations', scroll: 'presentations' },
    ],
    hero: { title: 'Hot, fresh and ready to enjoy' },
    assets: {
      title: 'Welcome to our Brand Box!',
      body:
        'Our guide to creating brilliant on-brand communications for Just Eat Takeaway.com. This is where you’ll find logos, guidelines, images, fonts and much more.',
      button: 'Download all assets',
      button_mobile: 'Copy link',
      sections: [
        { name: 'Logos', image: 'logos' },
        { name: 'Colours', image: 'colours' },
        { name: 'Press media', image: 'press' },
        { name: 'Presentation template', image: 'presentation' },
      ],
    },
    logos: {
      title: 'Logos',
      subtitle: 'Global and corporate logos',
      global_title: 'Global logos: ',
      global:
        'used for communications that run across lots of different countries and aren’t market specific, like multinational sponsorships and global marketing campaigns.',
      corporate_title: 'Corporate logos: ',
      corporate:
        'used for communications from our business itself, like in press releases to the media and in presentations to investors.',
      tiles: [
        {
          width: 39.5,
          image: 'Logo_Hor_Orange',
          animation: 'fade-right',
        },
        {
          width: 39.5,
          image: 'Logo_Hor_Mozza',
          animation: 'fade-left',
        },
        { width: 32.5, image: 'orange-stacked', animation: 'fade-up' },
        { width: 32.5, image: 'white-stacked', animation: 'fade-up' },
        { width: 11.5, image: 'Logo_House', animation: 'fade-up' },
      ],
      mobile_tiles: [
        {
          width: 100,
          image: 'white-horizontal-mobile',
          animation: 'fade-up',
          text: 'Horizontal logo',
        },
        {
          width: 100,
          image: 'white-stacked-mobile',
          animation: 'fade-up',
          text: 'Vertical logo',
        },
        {
          width: 100,
          image: 'white-house-mobile',
          animation: 'fade-up',
          text: 'House icon',
        },
      ],
      box_title: 'The house rules',
      box_body:
        'So that our logos are always readable and consistent wherever they appear, make sure they follow the guidelines below.',
      do: {
        title: "Do’s",
        list: [
          {
            instruction:
              'Do make sure there’s clear space around your logo. We call this the ‘logo exclusion zone’.',
            result: 'Do_Logo_exclusion',
          },
          {
            instruction:
              'Do place the logo on a background that has the right contrast ratio, like 3:1.',
            result: 'Do-Contrast_ratio',
          },
          {
            instruction:
              'Do use the horizontal logo where you can. If not, use the vertical logo.',
            result: 'Do_Horizontal_logo',
          },
        ],
      },
      dont: {
        title: "Don’ts",
        list: [
          {
            instruction:
              " Don't place logo on contextually coloured or busy backgrounds that affects legibility.",
            result: 'Dont_Busy_backgrounds',
          },
          {
            instruction: "Don't add effects like shadows or gradients.",
            result: 'Dont_Shadows_and_gradients',
          },
          {
            instruction: "Don't stretch, warp or compress the logo.",
            result: 'Dont_Stretch_warp_compress',
          },
        ],
      },
    },
    colours: {
      title: 'Colours',
      palette_title: 'Primary and supporting colours',
      dots: [
        {
          name: 'JET Orange',
          class: 'orange',
          type: 'Primary colour',
          details: [
            { name: 'CMYK', code: 'CO M65 Y100 KO' },
            { name: 'RGB', code: '255 128 0' },
            { name: 'Pantone', code: '144 U' },
            { name: 'Hex code', code: 'FF8000' },
          ],
          left: 23,
          top: 0,
          animation: 'fade-up',
        },
        {
          name: 'Charcoal',
          class: 'charcoal',
          type: 'Supporting colour',
          details: [
            { name: 'CMYK', code: 'CO M0 YO K95' },
            { name: 'RGB', code: '36 46 48' },
            { name: 'Pantone', code: '433 C' },
            { name: 'Hex code', code: '242E30' },
          ],
          left: 23,
          top: 0,
          animation: 'fade-up',
        },
        {
          name: 'Tomato',
          class: 'tomato',
          type: 'Supporting colour',
          details: [
            { name: 'CMYK', code: 'CO M78 Y93 K0' },
            { name: 'RGB', code: '247 94 40' },
            { name: 'Pantone', code: '1655 C' },
            { name: 'Hex code', code: 'F75E28' },
          ],
          left: 23,
          top: 0,
          animation: 'fade-up',
        },
        {
          name: 'Turmeric',
          class: 'turmeric',
          type: 'Supporting colour',
          details: [
            { name: 'CMYK', code: 'CO M27 Y93 KO' },
            { name: 'RGB', code: '246 194 67' },
            { name: 'Pantone', code: '142 C' },
            { name: 'Hex code', code: 'F6C243' },
          ],
          left: 12,
          top: 27,
          animation: 'fade-right',
        },
        {
          name: 'Mozzarella',
          class: 'mozzarella',
          type: 'Supporting colour',
          details: [
            { name: 'CMYK', code: 'C5 M5 Y5 KO' },
            { name: 'RGB', code: '239 237 234' },
            { name: 'Pantone', code: '50% WARM GRAY 1 C' },
            { name: 'Hex code', code: 'EFEDEA' },
          ],
          left: 71,
          top: 2,
          animation: 'fade-left',
        },
        {
          name: 'Aubergine',
          class: 'aubergine',
          type: 'Supporting colour',
          details: [
            { name: 'CMYK', code: 'C64 M80 Y35 K28' },
            { name: 'RGB', code: '91 61 91' },
            { name: 'Pantone', code: '520 C' },
            { name: 'Hex code', code: '5B3D5B' },
          ],
          left: 71,
          top: 2,
          animation: 'fade-left',
        },
        {
          name: 'Cupcake',
          class: 'cupcake',
          type: 'Supporting colour',
          details: [
            { name: 'CMYK', code: 'C31 M4 Y13 KO' },
            { name: 'RGB', code: '193 218 222' },
            { name: 'Pantone', code: '290 C' },
            { name: 'Hex code', code: 'C1DADE' },
          ],
          left: 41,
          top: 23,
          animation: 'fade-right',
        },
        {
          name: 'Berry',
          class: 'berry',
          type: 'Supporting colour',
          details: [
            { name: 'CMYK', code: 'C2 M42 Y16 KO' },
            { name: 'RGB', code: '242 166 176' },
            { name: 'Pantone', code: '700 C' },
            { name: 'Hex code', code: 'F2A6B0' },
          ],
          left: 64,
          top: 27,
          animation: 'fade-left',
        },
      ],
      ratios: {
        title: 'Colours and ratios',
        subtitle: 'We are an Orange brand. JET Orange.',
        body_1:
          'Yes, we know Orange isn’t a primary colour. But it’s our primary brand colour. This bold and energising hue is our most unique and memorable brand asset, and we use it across every touchpoint of our brand.',
        body_2:
          'When using our primary and supported colours together, our reccomended colour ratio is:',
        list: [
          '50-100% JET Orange',
          '0-50% Mozzarella or Mozzarella Tint',
          '0-20% Supporting Colours',
        ],
        body_3:
          'We prefer Orange and Mozzarella when it comes to background colours.',
        body_4: 'Supporting colours',
        body_5:
          'These other colours never replace Orange. They’ve been specially chosen to compliment the JET Orange. And to help our food photography look it’s best.',
      },
    },
    press: {
      title: 'Press media',
      images_title: 'Press images',
      images_body:
        'Whether you need a tasty looking dish or a courier shot for a press release, find high resolution images in the collections below.',
      sections: [
        {
          name: 'Food images',
          image: 'food-image',
          link: 'jet-food-images',
        },
        {
          name: 'Courier images',
          image: 'courier-image',
          link: 'jet-courier-images',
        },
        {
          name: 'Corporate images',
          image: 'meeting',
          link: 'jet-corporate-images',
        },
        {
          name: 'Infographics and maps',
          image: 'info-and-maps',
          link: 'jet-infographics-maps',
        },
      ],
    },
    presentation: {
      title: 'Presentations',
      example_title_1: 'Here’s one we',
      example_title_2: 'prepared earlier',
      example_body:
        'Download your own JET presentation template, complete with on-brand photography, colours, logos and fonts.',
      button_dark: 'Download for .ptt',
      button_dark_mobile: 'Copy link',
      button_light: 'Open in GoogleSlides',
    },
    outro: {
      title: 'Ready for more?',
      body:
        'See our whole brand story brought to life in our full brand visual identity and brand voice guidelines. And don’t forget to check out our project showcase, featuring some of our favourite creative work.',
      button_light: 'Sign in',
      button_light_alt: 'See more',
    },
    footer: {
      body_1: 'Can’t find what you’re looking for? Reach out to the team at ',
      link_1: 'creative.studio@justeattakeaway.com',
      body_2: ' for access to our full Brand Box.',
      body_3: 'For legal use of these assets, please read our ',
      link_2: 'Terms and Conditions',
      url: '/terms-and-conditions',
    },
  },
  more: {
    navigation: {
      links: [{ name: 'Brand guidelines' }],
      selections: [
        {
          image: 'logos-nav',
          title: 'Logos',
          scroll: 'logos',
          body:
            'Find out which logo to use and when, with advice for global and local contexts.',
        },
        {
          image: 'type-nav',
          title: 'Typography',
          scroll: 'typography',
          body:
            'Learn about our JET Sans font and the alternatives we use for internal contexts.',
        },
        {
          image: 'colours-nav',
          title: 'Colours',
          scroll: 'colours',
          body:
            'Hear the story of our orange, what it means, and our supporting colours too.',
        },
        {
          image: 'icons-nav',
          title: 'Icons',
          scroll: 'icons',
          body:
            'Browse our icons and learn how and when to use them in communications.',
        },
        {
          image: 'composition-16x9',
          title: 'Composition',
          scroll: 'composition',
          body:
            'See how we lay out communications to ensure we’re always on brand.',
        },
        {
          image: 'illustration',
          title: 'Illustration',
          scroll: 'illustration',
          body:
            'Enter the colourful world of our vibrant new illustration style.',
        },
        {
          image: 'photography-16x9',
          title: 'Photography',
          scroll: 'photography',
          body:
            'Explore different types of photography, how we use props and lighting.',
        },
        {
          image: 'cobranding-16x9',
          title: 'Co-branding',
          scroll: 'co-branding',
          body:
            'Discover how we introduce the JET brand world to our Restaurant Partners.',
        },
        // {
        //   image: 'motion',
        //   title: 'Motion and animation',
        //   scroll: 'motion',
        //   body:
        //     'Learn more about how we use motion and animation to deliver joy.',
        // },
        // {
        //   image: 'social-media',
        //   title: 'Social media',
        //   scroll: 'social-media',
        //   body:
        //     'Understand how to create on-brand social media assets for JET.',
        // },
      ],
    },
    hero: { title: 'JET Brand Box' },
    intro: {
      title: 'How to use the JET Brand Box',
      body_1:
        'Here you’ll find everything you need to create brilliant on-brand communications for Just Eat Takeaway.com. From fonts and style guides to food photography, infographics, logos and much more.',
      body_2: 'Can’t find what you’re looking for?',
      button_1: 'Contact Creative Studio',
      email: 'creative.studio@justeattakeaway.com',
    },
    logos: {
      title: 'Logos',
      subtitle: 'Toggle through the different types of JET logos',
      body:
        'These levels apply only in a visual (not structural) sense, and help us ensure visual consistency across all areas of our business.',
      slider: [
        {
          title: 'Global and corporate',
          info: {
            body:
              'Global comms include: international marketing campaigns, TVC assets that run across multiple countries and multinational sponsorships. Corporate comms include: business announcements, press releases and investor and stakeholder updates.',
            demo: 'logo-gif-global-corporate.gif',
          },
        },
        {
          title: 'Markets',
          info: {
            body:
              'Markets refers to JET’s localised brand identity, whose name changes in different global locations. All markets have a logo, complete with a horizontal and two vertical logo lockups. ',
            demo: 'logo-gif-markets.gif',
          },
        },
        {
          title: 'Sub-brands and products',
          info: {
            body:
              'Sub-brand and product logos refer to a part of our business that sits within our core brand identity like Scoober or [placeholder].',
            demo: 'logo-gif-sub-brands-products.gif',
          },
        },
        {
          title: 'Associated brands',
          info: {
            body:
              "Associated brand logos refer to a part of our business that doesn’t quite sit within our core brand identity. We add 'By' or 'Powered by' to ensure that the associated brand is still closely linked to us.",
            demo: 'associated-brand.png',
          },
        },
        {
          title: 'Networks and teams',
          info: {
            body:
              'Teams include internal departments like HR, marketing, tech or legal. Networks are official JET employee communities like BAME, STEM or LGBT+.',
            demo: 'network-teams.png',
          },
        },
      ],
      exclusion_zone: {
        title: 'Exclusion zone',
        body:
          'Our logos should be surrounded by clear space or ‘exclusion zone’ equal to one quarter of the height of the house icon. This space makes sure that other elements don’t crowd our logo.',
      },
      minimum_sizes: {
        title: 'Minimum sizes',
        body:
          'The minimum size for vertical stacked logos is measured from the top of the house icon to the baseline of the logotype. For horizontal logos, it’s measured from the top of the house icon to the base of the house icon.',
      },
    },
    typography: {
      title: 'Typography',
      subtitle: 'Play around with our bespoke typeface',
      body:
        'We’ve created a bespoke typeface that’s unique to us. JET Sans is our go-to and should be used wherever possible.',
      button: 'Download JET Sans Display',
      link:
        'https://www.dropbox.com/sh/cjs340de5f3n05s/AAAUoasrBqGDmMQ8q0yfER5pa?dl=0',
      sandbox: {
        weight: {
          title: 'Weight',
          options: [
            {
              text: 'JET Sans Regular',
              value: "'JETSans-Regular', sans-serif",
              food: 'Mezze Platter',
              intro: 'Usually used for body copy',
              rules: [
                'Leading 105% - 115%',
                'Tracking 0 to -5',
                'Optical kerning',
                'Sentence case only',
                'Italic available',
              ],
              instructions: [
                {
                  title: 'White or light background:',
                  text: 'Text under 18pt (24px) should be Charcoal',
                },
                {
                  title: 'On an orange background:',
                  text: 'Text should be white, and keep size over 10pt (14px)',
                },
              ],
            },
            {
              text: 'JET Sans Bold',
              value: "'JETSans-Bold', sans-serif",
              food: 'Packed Lunch',
              intro: 'Usually used for subheadings and call to actions ',
              rules: [
                'Leading 105% - 115%',
                'Tracking 0 to -5',
                'Optical kerning',
                'Sentence case only',
                'Italic available',
              ],
              instructions: [
                {
                  title: 'White or light background:',
                  text: 'Text under 18pt (24px) should be Charcoal',
                  heading: 'Headings over 18pt (24px) should be JET Orange',
                },
                {
                  title: 'On an orange background:',
                  text: 'Text should be white, and keep size over 10pt (14px)',
                },
              ],
            },
            {
              text: 'JET Sans Extra Bold',
              value: "'JETSans-ExtraBold', sans-serif",
              food: 'Bento Box',
              intro: 'Usually used for headings and headlines',
              rules: [
                'Leading 105% - 115%',
                'Tracking 0 to -5',
                'Optical kerning',
                'Sentence case only',
                'No italic version available',
              ],
              instructions: [
                {
                  title: 'White or light background:',
                  text: 'Text under 18pt (24px) should be Charcoal',
                  heading: 'Headings over 18pt (24px) should be JET Orange',
                },
                {
                  title: 'On an orange background:',
                  text: 'Text should be white, and keep size over 10pt (14px)',
                },
              ],
            },
            {
              text: 'JET Sans Black',
              value: "'JETSans-Black', sans-serif",
              food: 'Poke Bowl',
              intro: 'Usually used for ATL/TTL campaign headlines.',
              rules: [
                'Leading 105% - 115%',
                'Tracking 0 to -5',
                'Optical kerning',
                'Sentence case only',
                'Italic available',
              ],
              instructions: [
                {
                  title: 'White or light background:',
                  text: 'Text under 18pt (24px) should be Charcoal',
                  heading: 'Headings over 18pt (24px) should be JET Orange',
                },
                {
                  title: 'On an orange background:',
                  text: 'Text should be white, and keep size over 10pt (14px)',
                },
              ],
            },
          ],
        },
        italic: { title: 'Italic' },
        uppercase: { title: 'Uppercase' },
        colour: {
          title: 'Text colour',
          options: ['orange', 'white', 'charcoal'],
        },
      },
      alignment: {
        title: 'Alignment',
        body:
          'In most cases, text is left aligned or centre aligned. In some marketing contexts you can right-align short headlines. And in some campaign-level marketing contexts you can even offset alignment to create a visual effect.',
      },
    },
    colours: {
      title: 'Colours',
      intro: {
        title: 'Say it with orange, JET Orange',
        body:
          'Yes, we know orange isn’t a primary colour, but it’s our primary colour. We’re an orange brand, so it always takes centre stage. It represents our joyful personality, it’s bold, energising and we use it wherever we communicate.',
      },
      supporting: {
        title: 'Supporting colours',
        body:
          'Our supporting colours never replace orange, they support it doing its thing. They’re specially chosen to complement the orange colour and help food photography look its best.',
      },
      base: {
        title: 'Base colours',
        body:
          'A base colour is a colour that we use as a solid background. Our two base colour options are JET Orange and Mozzarella Tint 2. This tint of Mozzarella has been chosen to appear softer than pure white, but when it can’t be used, you can use pure white.',
      },
      how_much: {
        title: 'How much orange to use?',
        body_1:
          'Our reccomended colour ratio is: 50-100% Jet Orange, up to 50% Mozzarella or Mozzarella Tint, and up to 20% of a supporting colour.',
        body_2:
          'To make sure our primary orange colour is used to its fullest effect, you can use this as a guide for how much of each colour we can use. Or in other words “if in doubt, make it more orange”.',
      },
      orange_card: {
        name: 'JET Orange',
        class: 'orange',
        image: !1,
        type: 'Primary colour',
        details: [
          { name: 'CMYK', code: 'CO M65 Y100 KO' },
          { name: 'RGB', code: '255 128 0' },
          { name: 'Pantone', code: '144 U' },
          { name: 'Hex code', code: 'FF8000' },
        ],
      },
      cards: [
        {
          name: 'Berry',
          class: 'berry',
          image: !0,
          type: 'Supporting colour',
          details: [
            { name: 'CMYK', code: 'C2 M42 Y16 KO' },
            { name: 'RGB', code: '242 166 176' },
            { name: 'Pantone', code: '700 C' },
            { name: 'Hex code', code: 'F2A6B0' },
          ],
        },
        {
          name: 'Turmeric',
          class: 'turmeric',
          image: !0,
          type: 'Supporting colour',
          details: [
            { name: 'CMYK', code: 'CO M27 Y93 KO' },
            { name: 'RGB', code: '246 194 67' },
            { name: 'Pantone', code: '142 C' },
            { name: 'Hex code', code: 'F6C243' },
          ],
        },
        {
          name: 'Cupcake',
          class: 'cupcake',
          image: !0,
          type: 'Supporting colour',
          details: [
            { name: 'CMYK', code: 'C31 M4 Y13 KO' },
            { name: 'RGB', code: '193 218 222' },
            { name: 'Pantone', code: '290 C' },
            { name: 'Hex code', code: 'C1DADE' },
          ],
        },
        {
          name: 'Aubergine',
          class: 'aubergine',
          image: !0,
          type: 'Supporting colour',
          details: [
            { name: 'CMYK', code: 'C64 M80 Y35 K28' },
            { name: 'RGB', code: '91 61 91' },
            { name: 'Pantone', code: '520 C' },
            { name: 'Hex code', code: '5B3D5B' },
          ],
        },
        {
          name: 'Charcoal',
          class: 'charcoal',
          image: !0,
          type: 'Supporting colour',
          details: [
            { name: 'CMYK', code: 'CO M0 YO K95' },
            { name: 'RGB', code: '36 46 48' },
            { name: 'Pantone', code: '433 C' },
            { name: 'Hex code', code: '242E30' },
          ],
        },
        {
          name: 'Tomato',
          class: 'tomato',
          image: !0,
          type: 'Supporting colour',
          details: [
            { name: 'CMYK', code: 'CO M78 Y93 K0' },
            { name: 'RGB', code: '247 94 40' },
            { name: 'Pantone', code: '1655 C' },
            { name: 'Hex code', code: 'F75E28' },
          ],
        },
        {
          name: 'Mozzarella',
          class: 'mozzarella-1',
          image: !1,
          type: 'Supporting colour',
          details: [
            { name: 'CMYK', code: 'C5 M5 Y5 KO' },
            { name: 'RGB', code: '239 237 234' },
            { name: 'Pantone', code: '50% WARM GRAY 1 C' },
            { name: 'Hex code', code: 'EFEDEA' },
          ],
        },
        {
          name: 'Mozzarella Tint 1',
          class: 'mozzarella-2',
          image: !1,
          type: 'Supporting colour',
          details: [
            { name: 'CMYK', code: 'C3 M2 Y3 KO' },
            { name: 'RGB', code: '245 243 241' },
            { name: 'Pantone', code: '20% WARM GRAY 1 C' },
            { name: 'Hex code', code: 'F5F3F1' },
          ],
        },
        {
          name: 'Mozzarella Tint 2',
          class: 'mozzarella-3',
          image: !1,
          type: 'Supporting colour',
          details: [
            { name: 'CMYK', code: 'C1 M1 Y2 KO' },
            { name: 'RGB', code: '250 250 250' },
            { name: 'Pantone', code: '10% WARM GRAY 1 C' },
            { name: 'Hex code', code: 'FAFAFA' },
          ],
        },
      ],
    },
    composition: {
      title: 'Composition',
      subtitle: 'Explore the JET composition elements',
      grids: {
        title: 'Grids',
        content: [
          {
            text:
              'To make sure we’re consistent across all of our global channels, we use a simple, modular grid system to design assets.',
          },
          { text: '16:9 layout grid', strong: !0 },
          {
            text:
              'We use a 12 column layout grid structure for desktop and 16:9 presentations.',
          },
          {
            text:
              '12 columns allows for divisions of 12, 6, 4, 3, 2, and 1, giving us plenty of layout options to suit a variety of formats.',
          },
          { text: 'Other grid sizes', strong: !0 },
          {
            text:
              'We generally use a 6 column layout grid for 9:16, 4:5, and 1:1 formats. This allows us to divide the layout in half and into thirds.',
          },
        ],
      },
      cards: {
        title: 'Cards',
        content: [
          {
            text:
              'Cards are perfect for drawing attention to key details, and also allow us to give information a clear visual hierarchy.',
          },
          { text: 'Minimum size and corner radius', strong: !0 },
          {
            text:
              'The minimum size for a card is 100px by 100px (52mm by 52mm), with the corner radius always set to 30px (10.5mm).',
          },
          {
            text:
              'If text needs to be added inside the card, the internal margin should be 20px (7mm), and the internal corner radius should be 10px (3.5mm).',
          },
        ],
      },
      razor: {
        title: 'Razor',
        content: [
          {
            text:
              'The razor can be placed at the top, bottom, or either side of a layout, and can only be used with food photography and campaign imagery.',
          },
          { text: 'Using the razor', strong: !0 },
          {
            text:
              'Our razor can be used at three different angles depending on the type of photography it’s paired with:',
          },
          { text: '7.5° – front-on studio photography', strong: !0 },
          { text: '15° – three-quarter studio photography ', strong: !0 },
          { text: '30° – elevated studio photography', strong: !0 },
          {
            text:
              'With all lifestyle photography, use either the 7.5° or 15° angle.',
          },
        ],
      },
    },
    icons: {
      title: 'Icons',
      subtitle: 'Introducing the JET icons',
      body: [
        {
          text:
            'Our suite of functional icons take inspiration from our bespoke JET Sans typeface, making them both ownable and consistent with our brand identity.',
        },
        {
          text:
            'Our icon colours are chosen in the same way we choose text colours.',
        },
        { text: 'Base colours', strong: !0 },
        {
          text:
            'We use White icons with JET Orange, and Charcoal icons with Mozzarella Tint 2.',
        },
        { text: 'Supporting colour backgrounds', strong: !0 },
        {
          text:
            'We use Charcoal icons with Berry, Cupcake, Turmeric, and Mozzarella. We use White icons with Tomato, Aubergine, and Charcoal.',
        },
      ],
      picker_title: 'Explore our icons',
      colour_list: [
        'mozzarella',
        'orange',
        'cupcake',
        'berry',
        'turmeric',
        'tomato',
        'aubergine',
        'charcoal',
      ],
      icon_list: [
        'About Icon',
        'Add Icon',
        'Alcohol Icon',
        'Alert Icon',
        'App orders Icon',
        'Arrow down Icon',
        'Arrow left Icon',
        'Arrow up Icon',
        'Average order value Icon',
        'Backpack Icon',
        'Bag Icon',
        'Barcode Icon',
        'Basket Icon',
        'Battery Icon',
        'Benefits Icon',
        'Bike driver Icon',
        'Bitcoin Icon',
        'Brand awareness Icon',
        'Broken link Icon',
        'Bug Icon',
        'Burger and drink Icon',
        'Calendar Icon',
        'Camera Icon',
        'Car driver Icon',
        'Car Icon',
        'Case presentation Icon',
        'Cash Icon',
        'Chat Icon',
        'Checkbox selected Icon',
        'Checkbox unselected Icon',
        'Cheque Icon',
        'Chili Icon',
        'Churned customers Icon',
        'Clear Icon',
        'Closed Icon',
        'Cloud error Icon',
        'Cloud Icon',
        'Communities Icon',
        'Conversion rate Icon',
        'Corporate social responsibility Icon',
        'Creative studio Icon',
        'Credit card at home Icon',
        'Credit card Icon',
        'Cross Icon',
        'Curry Icon',
        'Cutlery Icon',
        'Data protection Icon',
        'Delete Icon',
        'Delivery fee Icon',
        'Delivery location Icon',
        'Delivery time Icon',
        'Dine-in Icon',
        'Discount Icon',
        'Dish Icon',
        'Dollar Icon',
        'Doner Kebab Icon',
        'Download cloud Icon',
        'Download Icon',
        'Download success Icon',
        'Drink Icon',
        'Ebike Icon',
        'Edit Icon',
        'Efficiency Icon',
        'Email Icon',
        'Employee directory Icon',
        'Euro Icon',
        'Facebook Icon',
        'Filter Icon',
        'Freeze Icon',
        'Fried chicken Icon',
        'Fries Icon',
        'Geolocation Icon',
        'Geolocation web Icon',
        'Google voice Icon',
        'Grid view Icon',
        'Grouped order Icon',
        'Hackathon Icon',
        'Headset Icon',
        'Heart Icon',
        'Helmet Icon',
        'Hide Icon',
        'Home Icon',
        'Ice cream Icon',
        'Image Icon',
        'Info Icon',
        'Insiders Icon',
        'Instagram Icon',
        'Interview Icon',
        'Kebab wrap Icon',
        'Kosher Icon',
        'Language Icon',
        'Laptop Icon',
        'Lei Icon',
        'Lev Icon',
        'Link Icon',
        'Linkedin Icon',
        'List Icon',
        'Loading Icon',
        'Location Icon',
        'Lock Icon',
        'Locked Icon',
        'Locker Icon',
        'Logout Icon',
        'Loyalty gift box Icon',
        'Loyalty Icon',
        'Market share Icon',
        'Marketing target Icon',
        'Meal voucher Icon',
        'Meet the team Icon',
        'Microphone Icon',
        'More Icon',
        'Nachos Icon',
        'New customer Icon',
        'Noodles Icon',
        'Notification Icon',
        'Office Icon',
        'Online payment Icon',
        'Online restaurants Icon',
        'Orders Icon',
        'Partnership Icon',
        'Peanut Icon',
        'Percentage Icon',
        'Person Icon',
        'Personality test Icon',
        'Phone Icon',
        'Pickup Icon',
        'Pin at home Icon',
        'Pizza Icon',
        'Policies Icon',
        'Pound Icon',
        'Printer Icon',
        'Profile face Icon',
        'Profile Icon',
        'Question Icon',
        'Radio selected Icon',
        'Recycle Icon',
        'Refresh Icon',
        'Remove Icon',
        'Restaurant Icon',
        'Restaurant location Icon',
        'Restaurant location pin Icon',
        'Revenue Icon',
        'Revenue per order Icon',
        'Review Icon',
        'Ribbon Icon',
        'Rocket ship Icon',
        'Salad Icon',
        'Sales Icon',
        'Sandwich Icon',
        'Scooter Icon',
        'Search Icon',
        'Settings Icon',
        'Share Icon',
        'Share of voice Icon',
        'Shekel Icon',
        'Show Icon',
        'Snapchat Icon',
        'Sort Icon',
        'Sound Icon',
        'Split chevron Icon',
        'Sponsored Icon',
        'stamp card 32 Icon',
        'Stampcard 10 Icon',
        'Star rating Icon',
        'Sushi Icon',
        'Swiss frank Icon',
        'T-box Icon',
        'T and C Icon',
        'Taco Icon',
        'Takeaway Pay Icon',
        'Tech test Icon',
        'Technology Icon',
        'Temperature Icon',
        'Thumbs up Icon',
        'Tick Icon',
        'Tiktok Icon',
        'Toilet Icon',
        'Travel Icon',
        'Trial day Icon',
        'Twitter Icon',
        'Under 16 Icon',
        'Under 18 Icon',
        'Under 21 Icon',
        'Upload Icon',
        'User welcome Icon',
        'Vegan Icon',
        'Vegetarian Icon',
        'Video interview Icon',
        'Vision strategy values Icon',
        'Voucher Icon',
        'Warning Icon',
        'Web Menu Icon',
        'Weekly payment Icon',
        'Wifi Icon',
        'World map Icon',
        'Wrap Icon',
        'Youtube Icon',
      ],
    },
    promotional: {
      title: 'Promotional badges',
      body_1:
        'We always use just one badge per asset. They can be used with both studio-shot food photography and lifestyle photography. The direction of the badge can come in from either the left or right.',
      body_2:
        'We use the Mozzarella Tint 2 badge in most instances. If it’s not possible to use Mozzarella Tint 2, you should use Charcoal. Please only use these two colour combinations, and only use badges that have been supplied by the Global Creative Studio. ',
    },
    illustration: {
      title: 'Illustration',
      subtitle: 'A delicious ingredient, best used sparingly',
      body_1:
        'While our food photography will always be the star of  the show, illustration plays a big supporting role.',
      body_2:
        'We use illustration when we need to add a human touch – whether it’s softening  an error message, explaining a complicated process, or celebrating that a customer’s order is on the way.',
      spinners: {
        title: 'Take a spin through our three illustration categories',
        gifs: [
          {
            image: 'illustration-categories-1-mobile',
            text:
              'It’s important that the illustrations of people we create are as diverse and inclusive as our community. To do this, we represent as many different ages, sizes, genders, ethnic backgrounds, and disabilities as possible.',
          },
          {
            image: 'illustration-categories-2-mobile',
            text:
              'From gift cards to delivery bags, we use illustrations to represent real-life objects associated with our brand.',
          },
          {
            image: 'illustration-categories-3-mobile',
            text:
              'We’re in the process of creating a range of delicious cuisine illustrations that can be used when food photography isn’t an option.',
          },
        ],
      },
      versus: {
        title: 'Simple versus complex',
        subtitle_1: 'Simplified illustrations',
        body_1:
          'These are made up of simple block colours with minimal texture and details. For use up to 600x600px where we need to keep elements simple for added clarity.',
        subtitle_2: 'Complex illustrations',
        body_2:
          'These are made up of detailed textures, shapes and colours. For use over 600x600px where finer details can be seen clearly.',
      },
      additional: {
        title: 'Additional colours',
        body_1:
          'As with all of our visual elements, our illustrations should be created using our primary and supporting brand colours.',
        body_2:
          'We also have some additional colours that are only for use in illustration. They have been carefully chosen to help bring our food and people to life.',
      },
      library: {
        search: 'Search JET illustrations',
        filter: 'Filter by type',
        filters: ['Food', 'People', 'Object'],
        items: [
          { name: 'new-food-burger', type: 'Food' },
          { name: 'new-food-drink', type: 'Food' },
          { name: 'new-food-fries', type: 'Food' },
          { name: 'new-food-indian', type: 'Food' },
          { name: 'new-food-noodles', type: 'Food' },
          { name: 'new-food-pasta', type: 'Food' },
          { name: 'new-food-pizza', type: 'Food' },
          { name: 'new-food-salad', type: 'Food' },
          { name: 'new-food-sushi', type: 'Food' },
          { name: 'new-food-taco', type: 'Food' },
          { name: 'new-food-thai', type: 'Food' },
          { name: 'new-object-bag', type: 'Object' },
          { name: 'new-object-ballons', type: 'Object' },
          { name: 'new-object-celebration', type: 'Object' },
          { name: 'new-object-delivery', type: 'Object' },
          { name: 'new-object-joyful', type: 'Object' },
          { name: 'new-object-lock', type: 'Object' },
          { name: 'new-object-megaphone', type: 'Object' },
          { name: 'new-object-order', type: 'Object' },
          { name: 'new-object-search', type: 'Object' },
          { name: 'new-object-speech', type: 'Object' },
          { name: 'new-people-chef-holding-bags', type: 'People' },
          { name: 'new-people-chef-order-pad', type: 'People' },
          { name: 'new-people-courier-bike', type: 'People' },
          { name: 'new-people-courier-delivery', type: 'People' },
          { name: 'new-people-courier-walk', type: 'People' },
          { name: 'new-people-customer-employee-branding', type: 'People' },
          { name: 'new-people-customer-order-joy', type: 'People' },
          { name: 'new-people-customer-using-app', type: 'People' },
          { name: 'new-people-employee-support', type: 'People' },
          { name: 'new-people-jet-employee', type: 'People' },

        ],
      },
    },
    photography: {
      title_1: 'Photography',
      title_2: 'and art direction',
      subtitle: 'We visualise the food experience in a few ways',
      body:
        'Our photography and our video content (known as "moving food") are divided into three categories: studio, hybrid and lifestyle. Read on to discover the difference between the definitions, and to understand when to use each approach.',
      types: [
        { image: 'photo-smoothie-studio', title: 'Studio photography' },
        { image: 'photo-party-studio', title: 'Hybrid photography' },
        { image: 'photo-life-studio', title: 'Lifestyle photography' },
      ],
      lists: [
        {
          title: 'Studio photography',
          items: [
            'Lower cost',
            'Shoot up to three images a day',
            'Works on JET Orange and razor backgrounds',
            'Can include Partner dishes',
            'Suitable for ATL comms'
          ],
        },
        {
          title: 'Hybrid photography',
          items: [
            'Medium cost with full buyout, no models',
            'Shoot up to 2 images a day',
            'Potential to include models',
            'Suitable for BTL comms',
          ],
        },
        {
          title: 'Lifestyle photography',
          items: [
            'Higher cost for BTL usage',
            'Shoot 2-3 images a day depending on food/occasion',
            'Longer shooting and prep times',
            'Suitable for BTL only'
          ],
        },
      ],
      studio: {
        intro: {
          title: 'Studio photography',
          body:
            'We strive to deliver joy in everything we do, including how we style our food. Not only do our dishes look delicious, they look undeniably real. Smudges, drips and smears are not to be shied away from. They add to the authenticity of the dish and are true to how delivered food arrives.',
          button: 'Browse the Vault',
          link:
            'https://vault.just-eat.com/assetbank-justeat/action/browseItems?categoryId=10201&categoryTypeId=2',
          type: '',
        },
        title: '"Food is our hero"',
        tips: [
          {
            title: 'Lighting and shadows',
            body_1:
              'All of our studio photography is shot under high-contrast lighting to create a shadow. This adds a graphic, dynamic element to the image. ',
            body_2:
              'For equipment, we use two Profoto lights for every shot. We place one with a hard head cover on the right of the set to give us a defined, sharp shadow. The other one is placed overhead to act as a fill.',
            image: 'photo-studio-lighting.png',
          },
          {
            title: 'Art direction tips',
            body_1:
              'Food and tableware should feel natural to the setting and any takeaway packaging in view should be from our sustainable range.',
            body_2:
              'Supporting colours are used as accents, both in the ingredients of dishes and in propping. At least one logo should always be visible in all of our photography, but logos should never be more prominent than the food. ',
            image: 'art-direction-tips.png',
          },
        ],
      },
      position: {
        title: 'We use three distinct angles with our Studio photography ',
        proximity: 'Proximity to razor edge',
        reading: 'Angle reading',
        specifications: 'Specifications',
        tick: {
          outcome:
            'The shadow of the food is almost touching the razor (tabletop) edge. ',
          image: 'check-white',
        },
        cross: {
          outcome:
            'The shadow and grubbins overlap the razor, breaking the tabletop illusion.',
          image: 'cross-white',
        },
        options: [
          {
            name: 'Front-on angle',
            detail: {
              body_1:
                'This angle is used to showcase delightful layers of food. Think burgers, sandwiches, and towers of waffles with cream.',
              body_2:
                'The razor should always sit below the top of the food to create a tabletop.',
              angle: '7.5',
              image: 'photo-studio-razor-7.5',
              width: 50,
              top: 165,
            },
          },
          {
            name: 'Three-quarter angle',
            detail: {
              body_1:
                'This angle is used to show off the contents of a bowl while still keeping the container visible. Think scoops of ice cream in wafer nests and avocado on toast.',
              body_2:
                'The top of the food should overlap the orange razor to add depth, but the shadow should remain on the tabletop.',
              angle: '15',
              image: 'photo-studio-razor-15',
              width: 50,
              top: 200,
            },
          },
          {
            name: 'Elevated angle',
            detail: {
              body_1:
                'This angle is used to show off the beautiful range of ingredients, colours, and textures of a dish. Think fresh poké, acai bowls, and rich shakshuka.',
              body_2:
                'The top of the food should overlap the orange razor to add depth but the shadow should remain on the tabletop.',
              angle: '30',
              image: 'photo-studio-razor-30',
              width: 40,
              top: 325,
              left: 220,
            },
          },
        ],
        above: {
          title: 'Above the line photography',
          body_1:
            'Our ATL images are our prime-time blockbuster food assets, and should be the go-to for campaigns. ',
          body_2:
            'Our collection of ATL images includes a variety of delicious cuisine images, as well menu items from big brands on our platform. These can sit on either our JET Orange background or razor graphic.',
          list: [
            'TVCs',
            'Digital billboards',
            'Printed billboards',
            'Newspapers',
            'Magazines',
            'Press',
            'Outdoor placement',
          ],
        },
        below: {
          title: 'Below the line photography',
          body_1:
            'Our BTL images represent the variety of delicious cuisines we offer on our platform, but are not styled to the same degree at ATL. These can sit on either our JET Orange background or razor graphic. ',
          body_2: '',
          list: [
            'Digital banners',
            'Email marketing (CRM)',
            'Events',
            'Social media',
            'Product',
          ],
        },
      },
      lifestyle: {
        title: 'Lifestyle photography',
        body_1:
          'Our mission is to deliver joy every day, to everyone. And our lifestyle photography is our way of recreating these moments of delight, whether it’s kicking back with friends over falafel, enjoying a solo poké bowl,or a family pizza party.',
        body_2:
          'We follow a few basic principles to ensure that our casting, location, props, colour and tone, and lighting fit the brand. ',
        button: 'Browse the Vault',
        link:
          'https://vault.just-eat.com/assetbank-justeat/action/browseItems?categoryId=10201&categoryTypeId=2',
        subtitle: '“Delivering joy”',
        sections: [
          {
            image: 'photo-casting',
            body_1:
              'Just like our illustrations, the people in our photography should be as diverse and inclusive as our community. That’s why we show people from a range of cultural and socioeconomic backgrounds, genders, sexualities, disabilities, and ages.',
            title: 'Casting',
            color: 'turmeric',
            text: 'charcoal',
          },
          {
            image: 'photo-location',
            body_1:
              'To achieve wide and global representation, we always capture environments that feel relatable, but still exciting. We do this by balancing our environments to be both authentic and aspirational, just as we do with our food.',
            title: 'Location',
            color: 'orange',
            text: 'white',
          },
          {
            image: 'photo-props',
            body_1:
              'The props in our images should always make sense for the model using them, the environment they’re in, and the food they sit alongside. You should always be able to see at least one branded item in each image. It could be a corner of our greaseproof paper, or a chopsticks wrapper.',
            title: 'Props',
            color: 'cupcake',
            text: 'charcoal',
          },
          {
            image: 'photo-colour',
            body_1:
              'The palette of our lifestyle photography should be in harmony with the colours of the food and environment we’re shooting in, with our supporting brand colours as accents. We edit our images to be warm in tone to complement our JET Orange hue. This also creates an inviting, friendly atmosphere.',
            title: 'Colour',
            color: 'aubergine',
            text: 'white',
          },
          {
            image: 'photo-lighting',
            body_1:
              'We can’t always count on bright, clear skies for great lighting, but we do aim to use natural light wherever we can. If we do need to use artificial lighting, we make sure it always looks authentic to the time of day we’re shooting — candlelit ambience for an evening meal, and fresh morning light for breakfast in bed.',
            title: 'Lighting',
            color: 'berry',
            text: 'charcoal',
          },
        ],
      },
      shoots: [
        {
          nav: 'Food moments',
          image: 'photo-food-moments',
          body_1:
            'Our lifestyle images balance food, people and our brand in their composition. Here, we tell stories that can stand alone as a snapshot in time, or be part of a bigger story.',
          body_2:
            'During photoshoots we create lots of different compositions, allowing us to capture a whole range of dishes, moods, and connections between our cast. For example, we can zoom in on one hand reaching for a poppadom, or zoom out and see a whole family sharing a feast.',
          body_3:
            'Whatever and wherever we’re shooting, we’re always positioned as having a seat at the table, never just watching from the sidelines.',
        },
        {
          nav: 'Courier',
          image: 'photo-courier',
          body_1:
            'We photograph our couriers looking happy in natural poses. When we’re shooting them in a group setting, we aim to capture a feeling of teamwork and camaraderie.',
          body_2:
            'If the images are localised, we capture recognisable surroundings and landmarks, but always make sure our couriers are the main focus of the image. ',
          body_3:
            'We capture at least one JET logo clearly in every image, and make sure all LMV (light motor vehicles, like our bikes), clothing and equipment is up-to-date with the latest branding.',
        },
        {
          nav: 'Office and colleagues',
          image: 'photo-office',
          body_1:
            'We take a documentary-style approach when photographing our colleagues, capturing authentic moments that feel true to a typical day at work.',
          body_2:
            'The images should feel warm to complement our JET Orange brand colour, and where possible, we should use our supporting colours as accents in props.',
          body_3:
            'The composition should be clean without distractions, with the action always in focus in the foreground. Where it feels natural, we can add our branding to the shot with lanyards, signage, and coffee mugs.',
        },
        {
          nav: 'Restaurant Partners',
          image: 'photo-restaurant-partner',
          body_1:
            'Our Restaurant Partners are photographed in the same documentary style we use for our JET colleagues. ',
          body_2:
            'Every business on our platform is unique, and we want to capture these individual personalities as effectively as possible. That means making sure the photos we take don’t feel stock-like, corporate, or staged.',
          body_3:
            'The colours we capture should feel rich and vibrant, and food should be handled with the same care and attention as it is in our food photography.',
        },
      ],
      moving: {
        title: '“Mouthwatering moments”',
        intro: {
          title: 'Moving food',
          body:
            'Every frame of our moving food content should make our audience hungry. ust like our photography, we have two types of moving food content – lifestyle and studio. Remember: this content is all about capturing the anticipation, so we never show dishes half-eaten.',
          button: 'Browse the Vault',
          link:
            'https://vault.just-eat.com/assetbank-justeat/action/browseItems?categoryId=17048&categoryTypeId=2',
        },
        gifs: ['icecream', 'edamame', 'bao'],
      },
    },
    co_branding: {
      title: 'Co-branding',
      intro: {
        title: 'When working with Restaurant Partners, we co-brand our assets',
        body_1:
          'For us, co-branding usually means adding a partner’s logo to our assets. This is to make sure that both brands are represented in the communications we’re sending out',
        body_2:
          'But before we decide how best to represent our brands, we have to agree who’s ‘brand world’ we’re in – ours, or our Restaurant Partner’s.',
      },
      icons: [
        {
          name: 'co-branding-logo-mcdonalds',
          top: 50,
          left: 55,
          animate: 'fade-up',
          mobile: {
            top: 90,
            left: 55,
          },
        },
        {
          name: 'co-branding-logo-ben-jerrys',
          top: 60,
          left: 80,
          animate: 'fade-left',
          mobile: {
            top: 30,
            left: 95,
          },
        },
        {
          name: 'co-branding-logo-burger-king',
          top: -5,
          left: 10,
          animate: 'fade-down',
          mobile: {
            top: -5,
            left: 4,
          },
        },
        {
          name: 'co-branding-logo-dominoes',
          top: 25,
          left: 80,
          animate: 'fade-left',
          mobile: {
            top: 10,
            left: 90,
          },
        },
        {
          name: 'co-branding-logo-dunkin',
          top: 90,
          left: 15,
          animate: 'fade-right',
          mobile: {
            top: 83,
            left: 90,
          },
        },
        {
          name: 'co-branding-logo-greggs',
          top: 25,
          left: 10,
          animate: 'fade-right',
          mobile: {
            top: 15,
            left: -8,
          },
        },
        {
          name: 'co-branding-logo-KFC',
          top: 60,
          left: 45,
          animate: 'fade-up',
          mobile: {
            top: -10,
            left: 55,
          },
        },
        {
          name: 'co-branding-logo-papa-johns',
          top: 80,
          left: 55,
          animate: 'fade-up',
          mobile: {
            top: 105,
            left: 30,
          },
        },
        {
          name: 'co-branding-logo-starbucks',
          top: 70,
          left: 10,
          animate: 'fade-right',
          mobile: {
            top: 95,
            left: 0,
          },
        },
        {
          name: 'co-branding-logo-subway',
          top: -5,
          left: 70,
          animate: 'fade-down',
          mobile: {
            top: 50,
            left: 90,
          },
        },
        {
          name: 'co-branding-logo-tacobell',
          top: 50,
          left: 70,
          animate: 'fade-left',
          mobile: {
            top: 100,
            left: 80,
          },
        },
      ],
    },
    our_world: {
      title: 'This is how we co-brand in our world',
      slides: [
        {
          title: 'Preferred OOO placements',
          body_1:
            'Here, we follow our JET visual identity and brand voice guidelines, but include our Restaurant Partner’s logo. All Restaurant Partner menu items should be shot in our art direction style and approved by the Restaurant Partner.',
          body_2:
            'When the partner logo is not visible on the packaging, we add their logo, but it’s not necessary if it’s included on the packagaing.  Co-branded comms that are in our brand world can be used both ATL and BTL.',
          list: [],
          background: 'co-branding-world-JET-background-1',
          images: [
            {
              image: 'resto-world-gif.gif',
              top: 30,
              left: 41,
              width: 22,
            },
          ],
        },
        {
          title: 'Large format OOO',
          body_1:
            'We recommend using our preferred logo placement in large format out of home (OOH). We use either our primary stacked or primary horizontal logos, depending on which version  best fits the format.',
          body_2:
            'Where it’s not possible to use our preferred logo placement, we use the primary co-branding logo lockup instead.',
          list: [],
          background: 'co-branding-world-JET-background-2',
          images: [
            {
              image: 'co-branding-world-JET-3.gif',
              top: 26,
              left: 25,
              width: 15,
            },
            {
              image: 'co-branding-world-JET-2.gif',
              top: 44,
              left: 48,
              width: 44,
            },
          ],
        },
        {
          title: 'Small and medium formats',
          body_1:
            'Where it’s not possible to use our preferred logo placement, we use the primary co-branding logo lockup instead. Check the next section to choose and position logos.',
          body_2: '',
          list: [],
          background: 'co-branding-world-JET-background-3',
          images: [
            {
              image: 'co-branding-world-JET-4.png',
              top: 27,
              left: 36.8,
              width: 24,
            },
          ],
        },
      ],
    },
    partner_world: {
      title: 'This is how we co-brand in our Restaurant Partner’s world',
      slides: [
        {
          title: 'Logo lockup, brand tab or brand strip',
          body_1:
            'Here, our Restaurant Partner’s brand visual identity and voice guidelines take the lead, with our logo included on the assets. We recommend our partners use their own guidelines for co-branded lockups.',
          body_2:
            'If there are no clear guidelines, we recommend using our primary co-branding logo lockup, our brand tab or our brand strip depending on what works best with their guidelines.',
          list: [],
          background: 'co-branding-world-RP-background-4',
          images: [
            {
              image: 'co-branding-world-RP-1.gif',
              top: 30,
              left: 37,
              width: 23,
            },
          ],
        },
        {
          title: 'Exceptional cases',
          body_1:
            'Very occasionally, we have no option but to use a mono version of our logo. We always use a white logo where we can, but if that’s not possible, there are two backup options:',
          list: [
            'A white logo inside a JET Orange card',
            'A JET Orange logo inside a Mozzarella Tint 2 card',
          ],
          body_2:
            'If neither of these options are suitable, we can use a black mono version of our logo. Please make sure that using this logo has been approved by the Global Brand Team, and please allow adequate time for your request to use the logo to go through our approval process.',
          background: 'co-branding-world-RP-background-5',
          images: [
            {
              image: 'co-branding-world-RP-2.png',
              top: 30,
              left: 40.5,
              width: 23,
            },
          ],
        },
      ],
    },
    brand_lockup: {
      title: 'Primary horizontal logo lockup',
      body_1:
        'Our logo should come first, followed by a divider line. The line should be placed in the middle of the two logos at an equal distance from both, and setat 2pt or 2px stroke weight with rounded caps.',
      body_2:
        'We work out the partner logo safe area and dividing line height by measuring vertically from the top of our house icon to the baseline of our logotype(the text part of our logo).',
    },
    secondary_lockup: {
      title: 'Secondary and multiple logo lockups',
      body_1:
        'If the primary horizontal logo lockup is not condusive to the layout, there are three other secondary logos available; vertical, horizontal stacked and horizontal. The divider line styling and safe area instructions remain unchanged. ',
      body_2:
        'When we need to use our logo alongside multiple Restaurant Partner logos, we use the same system as the primary horizontal logo lockup to define the spacing. This is also possible to do in a vertical alignment. ',
      orange: {
        title: 'Logos on an orange background',
        body:
          'When our partner logos are used on our JET Orange background, we recommend using mono white versions. Please check our partner’s brand guidelines to ensure that this is possible. If not, we recommend  using full colour logos on a Mozzarella Tint 2 background or card.',
      },
      tab: {
        title: 'Using the tab',
        body:
          'Our primary tab uses a white logo on a JET Orange background and is always our preferred option.If the primary tab cannot be used, for layout or background reasons, there is the option to use the secondary tab.',
      },
    },
    footer: {
      body_1: 'Can’t find what you’re looking for? Reach out to the team at ',
      link_1: 'creative.studio@justeattakeaway.com',
      body_2: ' for access to our full Brand Box.',
      body_3: 'For legal use of these assets, please read our ',
      link_2: 'Terms and Conditions',
      url: '/terms-and-conditions',
    },
  },
  terms: {
    title_1: 'Just Eat Takeaway.com Brand Box Terms and Conditions',
    body_1: [
      'This page sets out the terms and conditions ("Website Terms") on which we, Just Eat.co.uk Ltd ("we", "our" or "JUST EAT"), provide access to our website X  (together, "the Website").',
      'By accessing the Website, you indicate that you accept these Website Terms. If you do not accept these Website Terms, you should leave the Website immediately.',
      'We reserve the right to change these Website Terms from time to time by changing them on this page.',
    ],
    title_2: '1. WEBSITE ACCESS AND TERMS',
    body_2: [
      '1.1. Website access: You are permitted to use the content on the Website, print and download extracts from the Website for your own personal non-commercial use on the following basis:',
      'a) You must not misuse the Website (including by hacking or "scraping").',
      'b) Unless otherwise stated, the copyright and other intellectual property rights in the Website and in material published on it (including without limitation photographs and graphical images) are owned by us and/or our licensors. ',
      'These works are protected by copyright laws and treaties around the world and all rights are reserved. For the purposes of these Website Terms, any use of extracts from the Website, without our permission, is prohibited.',
      'c) You must not modify the digital or paper copies of any materials that you print off in accordance with paragraph 1.1 and you must not use any pictures, photographs or any other graphics, video or audio sequences separately from any accompanying text.',
      'd) You must ensure that our status as the author of the material on the Website is always acknowledged.',
      'e) You are not allowed to use any of the materials on the Website or the Website itself for commercial purposes without obtaining a licence from us to do so.',
      'f) Except as stated in paragraph 1.1, the Website may not be used, and no part of the Website may be reproduced or stored in any other website or included in any home or more electronic retrieval system or service, without our prior written permission.',
      'e) Any rights not expressly granted in these Website Terms are reserved.',
    ],
  },
}
